import { useLayoutEffect } from 'react'

// useFitToScreen — keeps a position:fixed menu fully on screen.
//
// Opens beside the click point: to the right of x by default (or to the left
// when the caller passes openLeft, i.e. x is the menu's right edge), and
// FLIPS to the other side when the preferred side would run off screen.
// Vertically the same: below the click by default, FLIPPED above it when the
// bottom would run off screen. It measures the menu's
// real rendered size, so no menu needs a hand-guessed width/height, and it
// runs before paint on every render, so a menu that grows keeps fitting.
// Overrides left/top/transform on the element; the caller's inline style is
// just the first guess.
const M = 8   // gap to the viewport edge

export default function useFitToScreen(ref, show, x, y, openLeft = false) {
  useLayoutEffect(() => {
    const el = ref.current
    if (!show || !el) return
    const { width: w, height: h } = el.getBoundingClientRect()
    const vw = window.innerWidth, vh = window.innerHeight
    let left = openLeft ? x - w : x
    if (!openLeft && left + w > vw - M) left = x - w     // no room right → go left
    if (openLeft && left < M) left = x                   // no room left → go right
    left = Math.max(M, Math.min(left, vw - w - M))
    let top = y
    if (top + h > vh - M) top = y - h                    // no room below → go above
    top = Math.max(M, Math.min(top, vh - h - M))
    el.style.left = `${left}px`
    el.style.top = `${top}px`
    el.style.transform = 'none'
  })
}